import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-timer',
    templateUrl: './timer.component.html',
    styleUrls: ['./timer.component.scss']
})
export class TimerComponent implements OnInit {
    minutes: number = 1;
    seconds: number = 0;

    @Output() timerComplete: EventEmitter<void> = new EventEmitter<void>();

    private timerInterval: any; // Store the interval reference

    ngOnInit(): void {
        this.startTimer();
    }

    startTimer(): void {
        this.stopTimer(); // Stop the timer if it is already running

        this.timerInterval = setInterval(() => {
            if (this.minutes === 0 && this.seconds === 0) {
                // Timer has reached 0:00
                this.stopTimer();
                this.timerComplete.emit();
                return;
            }

            if (this.seconds === 0) {
                // Decrement minutes and set seconds to 59 when seconds reach 0
                this.minutes--;
                this.seconds = 59;
            } else {
                // Decrement seconds by 1
                this.seconds--;
            }
        }, 1000);
    }

    stopTimer(): void {
        clearInterval(this.timerInterval);
    }

    restartTimer(): void {
        this.minutes = 1;
        this.startTimer();
    }
}
